(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("downloadsLearnerAccess", {
        templateUrl: "app/account/learnerAccess/learningItemType/downloadsLearnerAccess.component.html",
        require: {
            parentCtrl: "^^learningItemLearnerAccessModal"
        },
        controller: ["assignmentLearnerAccessDownloadsResource", "messageService", "$state", "$translate", "_", DownloadsLearnerAccessCtrl],
        controllerAs: "vm"
    });
    function DownloadsLearnerAccessCtrl(assignmentLearnerAccessDownloadsResource, messageService, $state, $translate, _) {
        var vm = this;
        this.$onInit = function () {
            vm.assignment = vm.parentCtrl.assignment;
            vm.downloadDisabled = vm.assignment.pathExpiringOrExpired && vm.assignment.pathExpiryType === "Path";
            load();
        };
        //////////////////////////////////////////////////////////////////////////////
        function load() {
            assignmentLearnerAccessDownloadsResource.get({ id: vm.assignment.id }, function (result) {
                vm.data = result;
                switch (vm.assignment.assignmentStatus) {
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        if (vm.assignment.expiring)
                            setupRequalifyButton();
                        break;
                    case 4:
                        setupRequalifyButton();
                        break;
                }
                vm.parentCtrl.contentLoaded = true;
            });
        }
        vm.download = function (btn, file) {
            if (btn.target.disabled) {
                return;
            }
            btn.target.disabled = true;
            if (vm.assignment.assignmentStatus === 4) {
                var message = $translate.instant("learningItem.learnerAccess.downloadableFile.expiredDownload");
                alert(message);
                return;
            }
            file.downloading = true;
            assignmentLearnerAccessDownloadsResource.download({ id: vm.assignment.id, fileId: file.id }, function (result) {
                file.downloading = false;
                file.downloadCount = result.downloadCount;
                var link = document.createElement("a");
                link.download = file.fileName;
                link.href = file.url;
                link.target = "_self";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                if (vm.assignment.assignmentStatus <= 2) {
                    if (_.every(vm.data.files, function (file) { return file.downloadCount > 0; }))
                        vm.parentCtrl.load();
                }
            });
        };
        var setupRequalifyButton = function () {
            vm.downloadDisabled = true;
            vm.parentCtrl.buttons = "requalify.tpl";
            vm.parentCtrl.requalify = vm.requalify;
        };
        vm.requalify = function (btn) {
            if (btn.target.disabled)
                return;
            btn.target.disabled = true;
            vm.assignment.$requalify({ number: $state.params.number, version: $state.params.version, code: $state.params.code }, function () {
                vm.assignment.assignmentStatus = 1;
                vm.assignment.expired = false;
                vm.assignment.expiring = false;
                vm.parentCtrl.assignmentStatusClass = "assigned";
                vm.parentCtrl.buttons = "";
                vm.downloadDisabled = false;
                load();
            }, function () {
                messageService.error("common.genericError");
            });
        };
    }
}());
